<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <Filter
                            :sns="false"
                            :resultType="false"
                            :resultDetailType="false"
                            :nation="false"
                            :isMonitoring="false"
                            :aiState="true"
                            :type="false"
                            :selectOption="state.selectOption"
                            @search="filterSearch"
                            @reset="resetSearch"
                        ></Filter>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn" @click="checkAll()">전체선택</button>
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" />
                                </button>
                            </div>
                            <div class="board_top_btns_right">
                                <div class="count">{{ numberFormat(state.totalLength) }}건</div>
                                <select name="" id="" class="select" v-model.number="state.perPage">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="70">70</option>
                                    <option value="100">100</option>
                                </select>
                                <div class="change_list_btns">
                                    <button
                                        type="button"
                                        class="list_btn"
                                        :class="state.layer === 0 ? 'on' : ''"
                                        @click="changeLayer(0)"
                                    ></button>
                                    <button
                                        type="button"
                                        class="gal_btn"
                                        :class="state.layer === 1 ? 'on' : ''"
                                        @click="changeLayer(1)"
                                    ></button>
                                </div>
                            </div>
                        </div>
                        <div class="gal_list_wrap" :class="state.layer === 1 ? 'card' : ''">
                            <template v-if="!state.isLoading">
                                <template v-if="result.list.length !== 0">
                                    <ul :class="state.layer === 0 ? 'gal_list' : 'gal_list_v2'">
                                        <li v-for="(item, idx) in result.list" :class="item.aiState === 1 ? 'detect' : ''">
                                            <div :class="[state.layer === 0 ? 'gal_list_con' : 'gal_con', ,]">
                                                <template v-if="state.layer === 0">
                                                    <div>
                                                        <label class="chk">
                                                            <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                            <span></span>
                                                        </label>
                                                        <img
                                                            v-if="item.aiState === 1"
                                                            :src="require('@/assets/common/report_wh.png')"
                                                            style="background: red; margin-top: 10px; width: 100%"
                                                        />
                                                    </div>
                                                    <div class="gal_thumb" @click="isDetailModal(item)">
                                                        <div class="gal_thumb_img">
                                                            <img
                                                                :src="item.file ? item.file : require('@/assets/common/NoImg.png')"
                                                                @error="errorImg"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="gal_thumb_info_div">
                                                        <ul class="gal_info_list">
                                                            <li class="gal_info_top">
                                                                <div class="gal_info_tit">
                                                                    <b>순번</b>
                                                                    <span>
                                                                        {{
                                                                            state.currentPage === 1
                                                                                ? idx + 1
                                                                                : state.perPage * (state.currentPage - 1) + idx + 1
                                                                        }}
                                                                    </span>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">고유번호</div>
                                                                <div class="gal_info_con">{{ item.idx }}</div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">플랫폼</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.platform }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">제목</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.title }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">카테고리</div>
                                                                <div class="gal_info_con" v-html="item.category"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">등록일자</div>
                                                                <div class="gal_info_con">
                                                                    {{ formatDate(item.createDate) }}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <ul class="gal_info_list">
                                                            <li>
                                                                <div class="gal_info_tit">판단여부</div>
                                                                <div
                                                                    class="gal_info_con"
                                                                    v-text="item.aiState === 1 ? '판단됨' : '판단 안됨'"
                                                                ></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">판단근거</div>
                                                                <div class="gal_info_con" v-html="item.judgmentReason"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">탐지근거</div>
                                                                <div class="gal_info_con" v-html="item.detectionReason"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">내용</div>
                                                                <div class="gal_info_con" v-html="item.content"></div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                                <template v-if="state.layer === 1">
                                                    <div class="gal_top_box">
                                                        <div class="gal_top_left">
                                                            <label class="chk">
                                                                <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                                <span></span>
                                                            </label>
                                                        </div>
                                                        <div class="gal_thumb">
                                                            <div class="gal_thumb_img">
                                                                <img
                                                                    :src="item.file ? item.file : require('@/assets/common/NoImg.png')"
                                                                    @error="errorImg"
                                                                    @click="isDetailModal(item)"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="gal_top_txt">
                                                            <div>
                                                                <div class="gal_info_top_box">
                                                                    <p class="gal_info_top">
                                                                        <b>순번</b>
                                                                        <span>
                                                                            {{
                                                                                state.currentPage === 1
                                                                                    ? idx + 1
                                                                                    : state.perPage * (state.currentPage - 1) + idx + 1
                                                                            }}
                                                                        </span>
                                                                    </p>
                                                                    <p class="gal_info_top">
                                                                        <b>고유번호</b>
                                                                        <span>{{ item.idx }}</span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="gal_info_div">
                                                        <ul class="gal_info_list">
                                                            <li>
                                                                <div class="gal_info_tit">플랫폼</div>
                                                                <div class="gal_info_con" v-html="item.platform"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">내용</div>
                                                                <div class="gal_info_con" v-html="item.content"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">탐지근거</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.detectionReason }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">판단근거</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.judgmentReason }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">카테고리</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.category }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">등록일자</div>
                                                                <div class="gal_info_con">
                                                                    {{ formatDate(item.createDate) }}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    <NoResult class="result_load"></NoResult>
                                </template>
                                <PageBtn
                                    v-if="result.list.length !== 0 && !state.isLoading"
                                    :currentPage="state.currentPage"
                                    :totalLength="state.totalLength"
                                    :perPage="state.perPage"
                                    @onPaging="handlePageChange"
                                ></PageBtn>
                            </template>
                            <template v-else>
                                <Spinner :isLoading="state.isLoading" class="result_load"></Spinner>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isModalOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
</template>
<script lang="ts">
    import {
        apiService,
        Header,
        Menu,
        onMounted,
        reactive,
        returnCode,
        PageBtn,
        numberFormat,
        formatDate,
        useRoute,
        watch,
        userStore,
        NoResult,
        Filter,
        globalStore,
        router,
        Popup,
        Spinner,
        dateFormat,
        errorImg,
    } from "@/BaseComponent";
    import type { ResultDetail } from "@/services/api/ai";
    import { watcherbotSearchResult } from "@/services/modalUtils";
    export default {
        props: [],
        components: {
            Header,
            Menu,
            PageBtn,
            Filter,
            NoResult,
            Popup,
            Spinner,
        },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const searchIdx = route.params.idx as any;

            const { changeCode } = returnCode();
            const state = reactive({
                isLoading: true,
                checkAll: false,
                checkList: [] as Array<number>,
                selectOption: [
                    { idx: 1, text: "제목" },
                    { idx: 2, text: "플랫폼" },
                ] as Array<any>,
                isModalOpen: false,
                layer: 0 as number,
                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 100 as number,
                filterData: {} as any,
            });
            const result = reactive({
                list: [] as ResultDetail[],
                detail: {} as any,
            });
            const modal = reactive({
                title: "" as string,
                content: {
                    title: "" as string,
                    main: {
                        title: "검색정보" as string,
                        data: "" as any,
                        class: "thumb_con",
                        render: (data: any) => {
                            return watcherbotSearchResult(data);
                        },
                    },
                    subTitle: "" as string,
                    class: "thumb_con",
                    sub: {
                        title: "" as string,
                        data: "" as any,
                        class: "thumb_con",
                        render: (data: any) => {
                            return `<p>${data}</p>`;
                        },
                    },
                    img: {
                        data: "" as any,
                        name: "" as any,
                        render: (data: any) => {
                            return data ? data : `<img src="${require("@/assets/common/NoImg.png")}" alt="이미지 없음" />`;
                        },
                    } as any,
                } as any,
            });
            onMounted(() => {
                global.setSelectMenu(6);
                if (user.perPage) state.perPage = user.perPage;
                if (user.listLayer) state.layer = user.listLayer;
            });

            watch(
                () => state.perPage,
                () => {
                    user.setPerPage(state.perPage);
                    state.currentPage = 1;
                    getResultList();
                },
            );

            watch(
                () => state.checkList,
                () => (state.checkAll = state.checkList.length === result.list.length),
            );

            const getResultList = async () => {
                state.isLoading = true;
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    startDate: state.filterData ? dateFormat(new Date(state.filterData.date[0])) : "",
                    endDate: state.filterData ? dateFormat(new Date(state.filterData.date[1])) : "",
                    searchType: state.filterData ? state.filterData.searchType : null,
                    searchContent: state.filterData ? state.filterData.searchContent : "",
                    aiState: state.filterData ? state.filterData.aiState : "",
                };
                const res = await apiService.ai.getResultList(searchIdx, param);
                if (res.returnCode === 0) {
                    result.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 3) {
                    router.replace("/403");
                } else {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getResultList();
            };

            const changeLayer = (idx: number) => {
                state.layer = idx;
                user.setListLayer(idx);
            };

            const filterSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getResultList();
            };

            const resetSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getResultList();
            };

            const isDetailModal = (item: ResultDetail) => {
                state.isModalOpen = true;
                modal.title = "탐지 상세 보기";
                modal.content.main.data = item;
                modal.content.img.data = item.file;
                modal.content.img.name = item.imgRealName;
            };

            const modalClose = () => {
                state.isModalOpen = false;
            };

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/common/NoImg.png");
                }
            };

            const showImg = (value: any) => {
                modal.title = "검색이미지";
                modal.content.main.data = "";
                modal.content.img.data = value ? value : require("@/assets/common/NoImg.png");
                state.isModalOpen = true;
            };

            const checkAll = () => {
                if (!state.checkAll) state.checkList = result.list.map((item) => item.idx);
                else state.checkList = [];
            };

            const excelDownLoad = async () => {
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    startDate: state.filterData ? dateFormat(new Date(state.filterData.date[0])) : "",
                    endDate: state.filterData ? dateFormat(new Date(state.filterData.date[1])) : "",
                    searchType: state.filterData ? state.filterData.searchType : null,
                    searchContent: state.filterData ? state.filterData.searchContent : "",
                    aiState: state.filterData ? state.filterData.aiState : "",
                };
                const res: any = await apiService.ai.downExcelResult(searchIdx, param);

                if (res.status === 200) {
                    try {
                        const blob = res.data;
                        const fileUrl = URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.download = `탐지결과_상세리스트_${param.startDate}${param.endDate}.xlsx`;
                        link.href = fileUrl;
                        link.click();
                        URL.revokeObjectURL(fileUrl);
                        return alert("다운로드 완료 되었습니다.");
                    } catch (error) {
                        return alert("다운로드에 실패했습니다.");
                    }
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            return {
                state,
                result,
                modal,
                handlePageChange,
                numberFormat,
                formatDate,
                changeLayer,
                filterSearch,
                resetSearch,
                isDetailModal,
                modalClose,
                imgError,
                showImg,
                checkAll,
                errorImg,
                excelDownLoad,
            };
        },
    };
</script>

<style>
    #board_layer .gal_list .gal_thumb_img {
        width: 200px;
        height: 150px;
    }

    #board_layer .gal_list > li {
        background-color: #fff;
        padding: 0 20px;
    }

    #board_layer .gal_list > li.detect {
        /* border: 2px solid red; */
        background-color: #ff000017;
    }

    #board_layer .gal_list_v2 > li.detect {
        /* border: 2px solid red; */
        background-color: #ff000017;
    }

    #board_layer .gal_list .gal_list_con {
        display: flex;
        padding: 20px 0;
        gap: 14px;
        align-items: start;
        border-bottom: 1px solid #d9d9d9;
        position: relative;
    }
</style>
